import React from "react";
import "./Exclusive_Card.css";
import { Link } from "react-router-dom";

const Exclusive_Card = ({ views, link, img, uploadedDate }) => {

  const formatViews = (num) => {
    if (!num) return "0";

    num = Number(num); // convert safely

    if (num >= 1_000_000_000)
      return (num / 1_000_000_000).toFixed(1).replace(".0", "") + "B";

    if (num >= 1_000_000)
      return (num / 1_000_000).toFixed(1).replace(".0", "") + "M";

    if (num >= 1_000)
      return Math.floor(num / 1_000) + "K";

    return num.toString();
  };


  return (

    <div className="Exclusive_Card" onClick={() => window.open(link, "_blank")}>
      <div className="img_holder">
        <img src={process.env.PUBLIC_URL + img} className="inner_img" />
      </div>
      <div className="overlay"></div>
      <div className="bottom_div">
        <div className="left_side">
          <p className="views_text">{formatViews(views)} views</p>
          <p className="date_text">{uploadedDate}</p>
        </div>

        <div className="right_side">
          <img src="/assets/images/insight/banner/yt.png" className="yt_img" />
        </div>
      </div>
    </div>

  );
};

export default Exclusive_Card;
